import { Loader2 } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { formatMoney } from "@/pages/bindery/binderyFormatters";

interface Props {
  estimating: boolean;
  estimate: { unitPrice: number; totalPrice: number } | null;
  copies: number;
}

export function CostEstimateCard({ estimating, estimate, copies }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Cost estimate</CardTitle>
      </CardHeader>
      <CardContent className="space-y-2">
        {estimating ? (
          <div className="flex items-center gap-2 text-sm text-slate-500">
            <Loader2 className="h-4 w-4 animate-spin" /> Calculating…
          </div>
        ) : estimate ? (
          <>
            <Row label="Per copy" value={formatMoney(estimate.unitPrice)} />
            <Row
              label={`Total (${copies} copies)`}
              value={formatMoney(estimate.totalPrice)}
              emphasize
            />
            <p className="pt-2 text-xs text-slate-500">
              Final price may be adjusted by staff after the format check.
            </p>
          </>
        ) : (
          <p className="text-sm text-slate-500">Enter page count to see an estimate.</p>
        )}
      </CardContent>
    </Card>
  );
}

function Row({ label, value, emphasize }: { label: string; value: string; emphasize?: boolean }) {
  return (
    <div className="flex items-center justify-between">
      <span className="text-sm text-slate-600">{label}</span>
      <span
        className={`tabular-nums ${
          emphasize ? "text-base font-semibold text-slate-900" : "text-sm text-slate-900"
        }`}
      >
        {value}
      </span>
    </div>
  );
}
